import React from 'react'
import i18next from 'i18next'
import moment from 'moment'
import {ColumnsType} from 'antd/es/table'
import {ChargebackType} from '@/api'
import {Currencies, ChargebackStatus} from '@/constants'
import {getAmountWithCurrency, isEmptyOrSpaces} from '@/utils'
import {CardSchemeLabelWithIcon, DateTimeLabel, TableStatus} from '@/components'
import {TagType} from '@/components/dumb/Tag/props'
import {DATE_FORMAT} from '@/stores/chargebacks/ChargebacksTableStore/constants'

export const getColumns = (): ColumnsType<ChargebackType> => {
    return [
        {
            title: i18next.t('ChargebacksTableStore.amount'),
            dataIndex: 'amount',
            key: 'amount',
            align: 'right',
            width: 150,
            render: (item, object) => (
                <b>{getAmountWithCurrency(item, object.currency as Currencies)}</b>
            )
        },
        {
            title: i18next.t('ChargebacksTableStore.chargebackDate'),
            dataIndex: 'chargebackDate',
            key: 'chargebackDate',
            align: 'left',
            render: (date) => moment(date).format(DATE_FORMAT)
        },
        {
            title: i18next.t('ChargebacksTableStore.transactionDate'),
            dataIndex: 'transactionDate',
            key: 'transactionDate',
            render: (date) => <DateTimeLabel date={date} dateFormat={DATE_FORMAT} />
        },

        {
            title: i18next.t('ChargebacksTableStore.status'),
            dataIndex: 'status',
            key: 'status',
            align: 'left',
            width: 250,
            render: (v: ChargebackStatus) => {
                return !isEmptyOrSpaces(v) ? (
                    <TableStatus
                        statusProps={{
                            status: i18next.t(`enums:chargebackStatus.${v}`, { defaultValue: v }),
                            type:
                                v === ChargebackStatus['chargeback-reversal']
                                    ? TagType.Success
                                    : TagType.Default,
                            iconType: 'refund'
                        }}
                    />
                ) : null
            }
        },

        {
            title: i18next.t('ChargebacksTableStore.reason'),
            dataIndex: 'reasonCodeCategory',
            key: 'reasonCodeCategory',
            render: (v) => i18next.t(`enums:reasonCodeCategory.${v}`, { defaultValue: v })
        },

        {
            title: i18next.t('ChargebacksTableStore.paymentMethod'),
            key: 'paymentMethod',
            dataIndex: 'paymentMethod',
            render: (_, object) => (
                <CardSchemeLabelWithIcon cardScheme={object.cardScheme} title={object.cardMask} />
            )
        }
    ]
}
